const utcOffsetPattern = /^([+-])(\d{2}):(\d{2})$/;

function utcOffsetToTimeZone(sign: string, hours: string, minutes: string): string {
  const hourCount = Number(hours);
  const maxHours = sign === '+' ? 14 : 12;
  if (hourCount === 0 || minutes !== '00' || hourCount > maxHours) {
    return 'UTC';
  }
  return `Etc/GMT${sign === '+' ? '-' : '+'}${hourCount}`;
}

export function getLocalIanaTimeZone(): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone; // oxlint-disable-line new-cap
  const offset = utcOffsetPattern.exec(tz);
  if (offset) {
    const [, sign, hours, minutes] = offset;
    return utcOffsetToTimeZone(sign, hours, minutes);
  }
  return tz || 'America/Los_Angeles';
}
